import type { H5FeatureKey, Member } from './types'

// Older sessions may not have the new field yet; keep existing users functional until re-login.
export function featureAllowed(member: Member | null | undefined, feature: H5FeatureKey) {
  return member?.featureAccess?.[feature] !== false
}
